import styled from 'styled-components';

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`;

export const ErrorIcon = styled.span`
  font-size: 56px;
`;

export const BackLink = styled.div`
  margin-top: 16px;
  text-align: center;

  a {
    font-size: 14px;
    color: ${({ theme }) => theme.colors.grey[200]};
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.colors.grey.white};
    }
  }
`;
